"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RadioGroup2 = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var RadioGroup = function RadioGroup(props) {
  return /*#__PURE__*/_react.default.createElement(_RadioGroup2.default, props);
};

RadioGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node.isRequired,

  /** A CSS class to add to the root node of the component. */
  className: _propTypes.string,

  /**
   * The default input element value. Use when the component is not controlled.
   */
  defaultValue: _propTypes.any,

  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes.string,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing event.target.value (string).
   */
  onChange: _propTypes.func,

  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: _propTypes.any
};
var _default = RadioGroup;
exports.default = _default;
